export enum LocalStorageEnum {
  PACKAGE_SELECTION = "packageSelection",
}
